export const PAGE_TYPE_METADATA = Symbol('__PAGE_TYPE__');
